/* global defineProps, defineExpose */
<template>
  <div class="container" ref="printArea">
    <div class="header">
      <div>
        <div class="invoice-title">INVOICE # {{ invoiceNo }}</div>
        <ul class="info-list">
          <li><span class="info-label">Issue Date:</span> <span class="info-value">{{ issueDate }}</span></li>
          <li><span class="info-label">Due Date:</span> <span class="info-value">{{ dueDate }}</span></li>
          <li><span class="info-label">Film Code:</span> <span class="info-value">{{ filmCode }}</span></li>
          <li><span class="info-label">Role:</span> <span class="info-value">{{ role }}</span></li>
        </ul>
      </div>
      <div>
        <img src="https://beavor.back.escroud.com/image/image.png" alt="Ottawood Film Logo" class="logo">
      </div>
    </div>
    <div class="divider"></div>
    <div class="flex-row">
      <div style="margin-right: 48px;">
        <div class="section-title">BILL TO:</div>
        <div>
          <div class="payable-item">Ottawood Film Group Inc.</div>
          <div class="payable-item">68B Leek Cres, Unit 201</div>
          <div class="payable-item">Richmond Hill, ON. L4B 1H1</div>
          <div class="payable-item">business@ottawoodfilm.com</div>
        </div>
      </div>
      <div>
        <div class="section-title">PAYABLE TO:</div>
        <div class="payable-item">
          <span class="label">Name:</span>
          <span>{{ name }}</span>
        </div>
        <div class="payable-item">
          <span class="label">Address:</span>
          <span>{{ address1 }}</span>
        </div>
        <div class="payable-item" v-if="address2 !=''">
          <span class="label"></span>
          <span>{{ address2 }}</span>
        </div>
        <div class="payable-item">
          <span class="label"></span>
          <span>{{ city }}, {{ province }} {{ postalCode }}</span>
        </div>
        <div class="payable-item">
          <span class="label">Email:</span>
          <span>{{ email }}</span>
        </div>
        <div class="payable-item">
          <span class="label">{{ taxType }} <span v-if="taxType !== 'NR'"> #</span>:</span>
          <span>{{ taxId }}</span>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <table>
      <thead>
        <tr>
          <th>DESCRIPTION</th>
          <th style="text-align: right;">RATE</th>
          <th style="text-align: right;">QTY</th>
          <th style="text-align: right;">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in items" :key="idx">
          <td>{{ item.desc }}</td>
          <td class="amount">{{ item.rate }}</td>
          <td class="amount">{{ item.qty }}</td>
          <td class="amount">{{ (item.rate * item.qty).toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="summary">
      <div class="summary-item">
        <span class="summary-label">Subtotal:</span>${{subtotal}}
      </div>
      <div class="summary-item">
        <span class="summary-label">Tax (GST/HST):</span>${{tax}}
      </div>
      <div class="summary-item total">
        <span class="summary-label">Amount Due:</span>${{total}}
      </div>
    </div>
    <div class="divider"></div>
    <div class="section-title">BANK INFORMATION</div>
    <div class="bank-info">
      <div class="bank-info-column">
        <div class="bank-info-item">
          <span class="bank-label">Institution No.:</span>
          <span>{{ institutionNo }}</span>
        </div>
        <div class="bank-info-item">
          <span class="bank-label">Transit No.:</span>
          <span>{{ transitNo }}</span>
        </div>
        <div class="bank-info-item">
          <span class="bank-label">Account No.:</span>
          <span>{{ accountNo }}</span>
        </div>
      </div>
      <div class="bank-info-column">
        <div class="bank-info-item">
          <span class="bank-label">EMT Email:</span>
          <span>{{ emtEmail }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineExpose, ref } from 'vue';
defineProps({
  invoiceNo: String,
  issueDate: String,
  dueDate: String,
  filmCode: String,
  role: String,
  name: String,
  address1: String,
  address2: String,
  city: String,
  province: String,
  postalCode: String,
  email: String,
  taxType: String,
  taxId: String,
  items: Array,
  subtotal: String,
  tax: String,
  total: String,
  institutionNo: String,
  transitNo: String,
  accountNo: String,
  emtEmail: String,
});
const printArea = ref(null);
defineExpose({ printArea });
</script>
<style scoped>
body { font-family: Arial, sans-serif; color: #333333; margin: 40px; }
.container { width: 612px; margin: 0 auto; }
.header { display: flex; justify-content: space-between; align-items: flex-start; }
.logo { height: 40px;width: 135px; }
.invoice-title { font-size: 24px; letter-spacing: 0; margin-bottom: 0.5em; font-weight: bold;color: #333333;}
.info-list {
  padding: 0;
  list-style: none;
  width: 100%;
  text-align: left;
}
.info-list li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.5em;
  font-size: 1em;
}
.info-label {
  min-width: 82px;
  font-weight: bold;
  text-align: right;
  margin-right: 8px;
}
.info-value {
  margin-left: 8px;
  color: #333;
}
.section-title { font-weight: bold; font-size: 1.2em;  margin-bottom: 0.5em;color: #333333; }
.flex-row { display: flex;}
.flex-col { flex: 1; }
.divider { border-top: 2px solid #ccc; margin: 1.5em 0; }
table { width: 100%; border-collapse: collapse; margin-top: 1em; }
th, td { padding: 0.7em; text-align: left; }
th {color: #333333;}
.amount { text-align: right; }
.summary {
  margin-top: 1em;
  width: 250px;
  margin-left: auto;
  text-align: right;
}

.summary-item {
  margin-bottom: 8px;
}

.summary-label {
  margin-right: 4px;
}

.summary-value {
  min-width: 80px;
  text-align: right;
}

.total {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-top: 4px;
}
.bank-info {
  display: flex;
  gap: 32px;
  margin-top: 12px;
}

.bank-info-column {
  flex: 1;
}

.bank-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.bank-label {
  min-width: 110px;
  text-align: right;
  margin-right: 8px;
  font-weight: 500;
}

.bold { font-weight: bold; }

.payable-item {
  margin: 8px 0;
  display: flex;
  align-items: flex-start;
}
.label {
  min-width: 70px;
  text-align: right;
  margin-right: 8px;
  font-weight: 500;
}
tbody tr:nth-child(odd) { background: #F5F5F6; }
</style> 